import { useGoogleLogin } from '@react-oauth/google';

interface GoogleLoginButtonProps {
  onSuccess: (googleAccessToken: string) => void | Promise<void>;
  onError: () => void;
  disabled?: boolean;
}

export function GoogleLoginButton({ onSuccess, onError, disabled = false }: GoogleLoginButtonProps) {
  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => onSuccess(tokenResponse.access_token),
    onError,
  });

  return (
    <button
      data-testid="admin-login-button"
      type="button"
      onClick={() => googleLogin()}
      disabled={disabled}
      className="btn-primary mt-8 w-full"
    >
      Sign in with Google
    </button>
  );
}
